import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { useArticle } from '../article.hook';
import { ArticleRequest } from '../../../request/article.request';
import FileUploadView from '../../../view/file-upload.view';
import { TextEditorView } from '../../../view/text-editor.view';
import { handleFilter } from '../../../view/input.helper';

export const AddArticleComponent: React.FC<{ open: boolean, onCancel: () => void }> = ({ open, onCancel }) => {
    const [form] = Form.useForm();
    const { loading, updateLoading, saveArticle } = useArticle()

    const handleOk = () => {
        form.validateFields().then(values => {
            updateLoading(true);
            const articleRequest = {
                title: values["title"],
                thumbnail: values["thumbnail"],
                miniDescription: values["miniDescription"],
                description: values["description"],
                tagList: values["tagList"]
            } as ArticleRequest
            saveArticle(articleRequest, onSuccess, onFailure)
        });
    };

    const onSuccess = () => {
        updateLoading(false);
        form.resetFields()
        onCancel();
    }

    const onFailure = () => {
        updateLoading(false);
    }

    return (
        <Modal
            open={open}
            title="Add New Article"
            onCancel={onCancel}
            confirmLoading={loading}
            onOk={handleOk}
            okText={"Submit"}
            cancelText={"Cancel"}
            style={{ top: 8, maxWidth: 768 }}
            width={'90vw'}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="title"
                    label="Title"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="thumbnail"
                    label="Thumbnail"
                    rules={[{ required: true, message: 'Please add thumbnail' }]}
                >
                    <FileUploadView onChange={() => { }} />
                </Form.Item>

                <Form.Item
                    name="miniDescription"
                    label="Mini Description"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="tagList"
                    label="Tags"
                    rules={[{ required: true, message: 'Enter Tags' }]}
                >
                    <Select
                        mode="tags"
                        value='tagList'
                        maxTagCount='responsive'
                        style={{
                            width: '250px',
                            marginRight: '20px',
                        }}
                        filterOption={handleFilter}
                    />
                </Form.Item>


                <Form.Item
                    name="description"
                    label="Description"
                    rules={[{ required: true }]}
                >
                    <TextEditorView readOnly={false} />
                </Form.Item>

            </Form>
        </Modal>
    );
}